import { TooltipStyled } from './Layout.styled';

import React, { ReactElement } from 'react';

import { css, Theme } from '@emotion/react';
import styled from '@emotion/styled';
import Form from '@hangar31/rc-form';
import { FormProps } from '@hangar31/rc-form/dist/types';

/**
 * `data-e2e` is a TEST HOOK, and it is load-bearing. Emotion emits its
 * human-readable class label (`css-hash-ItemModalButton`) only in development;
 * a production build emits `css-hash` alone. Every e2e selector written as
 * `[class*="SomethingStyled"]` therefore matches nothing on a deployed
 * preview — which is why modal-open.spec.ts, build-class.spec.ts and
 * ministries-parity.spec.ts could never be gated. Don't remove these.
 */
export const ItemModalButtonStyled = (props: React.ComponentProps<'div'>) => (
  <TooltipStyled followCursor title="Click To Edit">
    <ItemModalButton data-e2e="item-card" {...props} />
  </TooltipStyled>
);
const ItemModalButton = styled.div(
  ({ theme }) => css`
    position: relative;

    cursor: pointer;

    input,
    label,
    textarea {
      cursor: unset;
    }

    > * {
      &:hover:after {
        position: absolute;
        top: -0.5rem;
        right: -0.5rem;
        bottom: -0.5rem;
        left: -0.5rem;
        z-index: -1;

        border: 1px dashed ${theme.colors.clickable};
        content: '';
      }
    }
  `
);

export const ItemModalStyled = styled<any>(Form)(
  // styled<any> makes the style-fn arg `any`, so annotate theme to keep it typed.
  ({ theme }: { theme: Theme }) => ({ h2: theme.font('sm', 'bl') }),
  ({ theme }: { theme: Theme }) => css`
    position: relative;
    z-index: 0;

    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 100%;

    header {
      position: sticky;
      top: 0;
      z-index: 1;

      display: flex;
      align-items: center;
      margin: 0 0 1rem 0;
      padding: 0.8rem 1.6rem;

      color: ${theme.colors.white};

      background: ${theme.colors.clickable};
      border-radius: ${theme.radius.md} ${theme.radius.md} 0 0;
      i {
        margin-right: 0.5rem;
      }
    }
    main {
      z-index: 0;

      flex: 1;
      /* height - header - footer */

      padding: 0 1.5rem;
      overflow: initial;
      overflow: auto;
    }
    footer {
      position: sticky;
      bottom: 0;

      display: flex;

      justify-content: flex-start;
      align-items: center;
      margin: 2rem 0 0 0;
      padding: 1rem 1.6rem;

      color: ${theme.colors.clickable};
      line-height: 1em;

      background: ${theme.colors.whiteDark};
      border-radius: 0 0 ${theme.radius.md} ${theme.radius.md};
    }
  `
) as <D extends Record<string, any>>(props: FormProps<D>) => ReactElement;

export const AutomationItemStyled = styled.div(
  ({ theme }) => theme.font('sm'),
  ({ theme }) => css`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin: 1rem 0;
    padding: 1rem 2rem;

    color: ${theme.colors.clickable};

    background: ${theme.colors.white};
    border-radius: ${theme.radius.md};
    cursor: pointer;

    i {
      margin-right: 1rem;
    }
  `
);
